import React from 'react';
import {MarkdownBlock} from '../shared/MarkdownBlock/MarkdownBlock.react';
import TextHighlightPrompt from './TextHighlightPrompt.react';

export default class TextHighlightExplanation extends React.Component {
  render() {
    const questionStoreName = this.props.storeName;
    const question = this.props.question;
    return (
      <div>
        <div className='text-highlight-explanation'>
          <h2>Correct Selections</h2>
          <TextHighlightPrompt
            explanation
            storeName={questionStoreName}
            question={question}
            isGuessSubmitted={true}
          />
        </div>
        <MarkdownBlock heading='Sample Response' text={question.getMeta().getSolutionText()} />
      </div>
    );
  }
}
